module.exports = __webpack_public_path__ + "static/step-3-30fbe842e53fdf7ececc9ec75ac98e9f.svg";